app.service('productCompare',function() {
	function init(){

	}
	return {
		init:init
	};
});
